import InflowDialog from './InflowDialog';

export default InflowDialog;
